module.exports = {
	"plans": {
		"attributes": {
			"code": "Código",
			"id": "Identificador",
			"name": "Nome",
			"status": "Status",
			"value": "Valor",
			"active": "Ativo",
			"inactive": "Inativo",
			"quantity": "Quantidade",
			"price": "Valor",
			"description": "Descrição",
			"periodicity": "Periodicidade",
			"suggested": "Sugerido",
			"statuses": {
				"true": "Ativo",
				"false": "Inativo"
			}
		},
		"placeholder": {
			"status": "Status",
			"id": "Ex.: 1234",
			"plan": "Ex.: Start",
			"code": "Ex.: Ab123"
		},
		"modal": {
			"confirm_changes": "Confirmar Alteração",
			"inactive_plan": "Inativar Plano",
			"active_plan": "Ativar Plano",
			"change_message": "Ao alterar o plano, o valor não será atualizado em assinaturas ativas.",
			"confirm_message": "<p>Deseja realizar a alteração no plano <strong>%{plan}</strong>?</p>",
			"inactive_plan_message": "Ao inativar este plano as assinaturas ativas não serão afetadas.",
			"active_plan_message": "Ao ativar este plano as assinaturas inativas não serão afetadas.",
			"inactive_message": "<p>Deseja realmente inativar o <strong>%{plan}</strong>?</p>",
			"active_message": "<p>Deseja realmente ativar o <strong>%{plan}</strong>?</p>"
		},
		"main": {
			"title": "Planos",
			"without_plans_registereds": "Você ainda não possui planos cadastrados.",
			"register_first_plan": "Cadastre seu primeiro plano",
			"begin_message": "Comece agora mesmo a realizar suas cobranças recorrentes cadastrando seus planos de forma simples e rápida. Através dos planos cadastrados seus clientes irão realizar a contratação e o pagamento das assinaturas.",
			"recomended": "Recomendado",
			"list_plans": "Lista de planos cadastrados"
		},
		"edit": {
			"edit": "Editar",
			"edit_plan": "Editar plano %{plan}",
			"show_plan_highlight": "Plano será apresentado em destaque na página de contratação.",
			"deadline_subscription": "Prazo de contrato de assinatura.",
			"apresentation": "Apresentação",
			"apresentation_information": "Informe o nome do plano e sua descrição, deixando claro todas as informações oferecidas neste plano.",
			"recomended_plan": "Definir como plano recomendado",
			"description": "Descrição",
			"value_and_periodicity": "Valor e Periodicidade",
			"deadline_message": "Defina o prazo de duração da cobrança e o valor do plano, que será cobrado conforme a periodicidade definido no campo cobrança.",
			"charging": "Cobrança",
			"period_plan": "Duração do plano",
			"value": "Valor",
			"alerts": {
				"enter_value": "Digite o valor do plano",
				"chose_name_plan": "Escolha um nome para seu plano",
				"fill_description": "Preencha uma descrição"
			},
			"placeholder": {
				"start": "Ex.: Start"
			}
		},
		"new": {
			"new_plan": "Incluir novo plano",
			"name": "Nome do plano",
			"code": "Código único do plano",
			"quantity": "Quantidade de vezes que o plano será cobrado",
			"apresentation": "Apresentação",
			"apresentation_information": "Informe o nome do plano e sua descrição, deixando claro todas as informações oferecidas neste plano.",
			"recomended_plan": "Definir como plano recomendado",
			"description": "Descrição",
			"value_and_periodicity": "Valor e Periodicidade",
			"deadline_message": "Defina o prazo de duração da cobrança e o valor do plano, que será cobrado conforme a periodicidade definido no campo cobrança.",
			"charging": "Cobrança",
			"period_plan": "Duração do plano",
			"value": "Valor",
			"alerts": {
				"enter_value": "Digite o valor do plano",
				"chose_name_plan": "Escolha um nome para seu plano",
				"fill_description": "Preencha uma descrição"
			},
			"popover": {
				"suggested": "Plano será apresentado em destaque na página de contratação.",
				"duration": "Prazo de contrato de assinatura.",
				"periodicity": "Período de contemplação do plano em meses. Ex: 6 (o plano será cobrado a cada 6 meses)"
			},
			"placeholder": {
				"start": "Ex.: Start"
			}
		},
		"show": {
			"title": "Detalhes",
			"details": "Detalhes do plano",
			"since": "Desde",
			"charge": "Cobrança",
			"plan_status": "Status do plano",
			"active_subscriptions": "Assinaturas ativas",
			"plan_name": "Nome do plano",
			"last_subscriptions": "Últimas assinaturas",
			"subscription": "Assinatura",
			"view_all_subscriptions": "Visualizar todas as assinaturas",
			"view_registered_plan": "Visualizar plano cadastrado",
			"every": "À cada",
			"months": "meses",
			"period_charge": "À cada %{period} meses"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/plans/pt-BR.yml
// module id = 588
// module chunks = 1